/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { ReactionBaseService } from '../reaction-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { EventSchemaDto } from '../models/event-schema-dto';
import { ReactionSchemaDto } from '../models/reaction-schema-dto';
import { SourceEventSchemaDto } from '../models/source-event-schema-dto';

@Injectable({ providedIn: 'root' })
export class SystemReactionControllerService extends ReactionBaseService {

  /**
   * Path part for operation systemReactionControllerGetSourceEventSchema
   */
  static readonly SystemReactionControllerGetSourceEventSchemaPath = '/v1/schema/{entity}/event/{sourceType}/{sourceId}/{newTriggerId}/source';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSourceEventSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSourceEventSchema$Response(params: {
    entity: string;
    sourceType: number;
    sourceId: string;
    newTriggerId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<SourceEventSchemaDto>> {

    const rb = new RequestBuilder(this.rootUrl, SystemReactionControllerService.SystemReactionControllerGetSourceEventSchemaPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('sourceType', params.sourceType, {});
      rb.path('sourceId', params.sourceId, {});
      rb.path('newTriggerId', params.newTriggerId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SourceEventSchemaDto>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSourceEventSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSourceEventSchema(params: {
    entity: string;
    sourceType: number;
    sourceId: string;
    newTriggerId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<SourceEventSchemaDto> {

    return this.getSourceEventSchema$Response(params).pipe(
      map((r: StrictHttpResponse<SourceEventSchemaDto>) => r.body as SourceEventSchemaDto)
    );
  }

  /**
   * Path part for operation systemReactionControllerGetEventSchema
   */
  static readonly SystemReactionControllerGetEventSchemaPath = '/v1/schema/{entity}/event/{eventType}/{newTriggerId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEventSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEventSchema$Response(params: {
    entity: string;
    eventType: string;
    newTriggerId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<EventSchemaDto>> {

    const rb = new RequestBuilder(this.rootUrl, SystemReactionControllerService.SystemReactionControllerGetEventSchemaPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('eventType', params.eventType, {});
      rb.path('newTriggerId', params.newTriggerId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EventSchemaDto>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getEventSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEventSchema(params: {
    entity: string;
    eventType: string;
    newTriggerId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<EventSchemaDto> {

    return this.getEventSchema$Response(params).pipe(
      map((r: StrictHttpResponse<EventSchemaDto>) => r.body as EventSchemaDto)
    );
  }

  /**
   * Path part for operation systemReactionControllerGetTriggerSchemas
   */
  static readonly SystemReactionControllerGetTriggerSchemasPath = '/v1/schema/{entity}/{trigger}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTriggerSchemas()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTriggerSchemas$Response(params: {
    entity: string;
    trigger: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<ReactionSchemaDto>> {

    const rb = new RequestBuilder(this.rootUrl, SystemReactionControllerService.SystemReactionControllerGetTriggerSchemasPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('trigger', params.trigger, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReactionSchemaDto>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTriggerSchemas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTriggerSchemas(params: {
    entity: string;
    trigger: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<ReactionSchemaDto> {

    return this.getTriggerSchemas$Response(params).pipe(
      map((r: StrictHttpResponse<ReactionSchemaDto>) => r.body as ReactionSchemaDto)
    );
  }

}
